import axios from "axios";
import encryptData from "@/helpers/encryptData";

const API_URL = process.env.VUE_APP_ROOT_API;

class AuthService {
  login(user) {
    this.logout();
    return axios
      .post(
        API_URL + "user/login",
        encryptData({
          email: user.email,
          password: user.password,
        })
      )
      .then((response) => {
        if (response.data.access) {
          localStorage.setItem("user", JSON.stringify(response.data));
        }

        return response.data;
      });
  }
  loginWithOTP(user) {
    this.logout();
    const { id, otp, proccesssFor } = user;
    let data = { email_otp: otp };
    if (proccesssFor == "mobile_otp") {
      data = { mobile_otp: otp };
    }
    return axios
      .patch(API_URL + "user/login-wia-otp/" + id, encryptData(data))
      .then((response) => {
        if (response.data.is_verify_email_otp_number) {
          if (response.data.user_data.access) {
            localStorage.setItem(
              "user",
              JSON.stringify(response.data.user_data)
            );
          }
        }
        return response.data;
      })
      .catch((error) => {
        return error;
      });
  }
  refreshToken(token) {
    console.log(token);
    return axios
      .post(API_URL + "user/token/refresh", {
        refresh: token,
      })
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
        localStorage.clear();
        window.location.reload();
      });
  }

  logout() {
    localStorage.clear();
    localStorage.removeItem("user");
    localStorage.removeItem("hotel");
  }
}

export default new AuthService();
